import { Divider, MenuItem, Select, type SelectProps } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';
import React, { useMemo } from 'react';

import {
  PropertyPolicyRelation,
  type FilterProperty,
} from '@/types/advanceFilter';

import { OPERATORS } from './OperatorSelect';
import { inlineDropdownStyle } from './conditionComponents';

interface PropertySelectProps {
  condition?: Condition;
  properties: FilterProperty[][];
  onChange: (condition: Condition) => void;
}

export default function PropertySelect({
  condition,
  properties,
  onChange,
  ...props
}: PropertySelectProps & Omit<SelectProps<FilterProperty>, 'onChange'>) {
  const conditionProperty = useMemo(
    () => properties.flat().find((c) => c.name === condition?.property),
    [properties, condition?.property]
  );
  return (
    <Select
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 'unset',
          },
        },
      }}
      sx={{ ...inlineDropdownStyle, fontWeight: 'medium', height: '100%' }}
      value={conditionProperty ?? ''}
      onChange={(event) => {
        const property = event.target.value as FilterProperty;
        onChange({
          ...condition,
          property: property.name,
          operator:
            OPERATORS[
              property.policyRelation ?? PropertyPolicyRelation.MultipleValues
            ][0].value,
          value: [],
        });
      }}
      {...props}
    >
      {properties
        .map((group, gi) =>
          group.map((p, i) =>
            i === group.length - 1 && gi < properties.length - 1
              ? [
                  <MenuItem key={p.name} value={p as never}>
                    {p.displayName}
                  </MenuItem>,

                  <Divider key={`${p.name}divider`} className='my-[8px]' />,
                ]
              : [
                  <MenuItem key={p.name} value={p as never}>
                    {p.displayName}
                  </MenuItem>,
                ]
          )
        )
        .flat()}
    </Select>
  );
}
